<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-new-beginnings-july-1987">
<h1 style="margin-top: 230px; font-family: Arial;">Part 1 <br/>New Beginnings: July 1987</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?78e4aa98